import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import AnimatedPage from "../components/AnimatedPage";
import axios from "axios";
import swal from "sweetalert";

// Danh sách quốc gia hỗ trợ
const COUNTRIES = [
    { code: "+84", flag: "https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Vietnam.svg", name: "VN" },
    { code: "+86", flag: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Flag_of_the_People%27s_Republic_of_China.svg", name: "CN" },
    { code: "+886", flag: "https://upload.wikimedia.org/wikipedia/commons/7/72/Flag_of_the_Republic_of_China.svg", name: "TW" },
    { code: "+852", flag: "https://upload.wikimedia.org/wikipedia/commons/5/5b/Flag_of_Hong_Kong.svg", name: "HK" },
    { code: "+853", flag: "https://upload.wikimedia.org/wikipedia/commons/6/63/Flag_of_Macau.svg", name: "MO" },
    { code: "+855", flag: "https://upload.wikimedia.org/wikipedia/commons/8/83/Flag_of_Cambodia.svg", name: "KH" },
    { code: "+66", flag: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg", name: "TH" },
    { code: "+856", flag: "https://upload.wikimedia.org/wikipedia/commons/5/56/Flag_of_Laos.svg", name: "LA" },
    { code: "+63", flag: "https://upload.wikimedia.org/wikipedia/commons/9/99/Flag_of_the_Philippines.svg", name: "PH" },
    { code: "+62", flag: "https://upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_Indonesia.svg", name: "ID" },
    { code: "+60", flag: "https://upload.wikimedia.org/wikipedia/commons/2/28/Flag_of_Malaysia.svg", name: "MY" },
    { code: "+65", flag: "https://upload.wikimedia.org/wikipedia/commons/4/48/Flag_of_Singapore.svg", name: "SG" },
    { code: "+95", flag: "https://upload.wikimedia.org/wikipedia/commons/8/8c/Flag_of_Myanmar.svg", name: "MM" },
    { code: "+81", flag: "https://upload.wikimedia.org/wikipedia/en/9/9e/Flag_of_Japan.svg", name: "JP" },
    { code: "+82", flag: "https://upload.wikimedia.org/wikipedia/commons/0/09/Flag_of_South_Korea.svg", name: "KR" },
    { code: "+91", flag: "https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg", name: "IN" },
    { code: "+1",  flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg", name: "US" },
    { code: "+44", flag: "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg", name: "UK" },
    { code: "+61", flag: "https://upload.wikimedia.org/wikipedia/commons/8/88/Flag_of_Australia_%28converted%29.svg", name: "AU" }
];

function Register() {
    const login = localStorage.getItem("user");
    const navigate = useNavigate();
    const [affiliate, setAffiliate] = useState(null);
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    
    const [isLoading, setIsLoading] = useState(false);
    const [isAgeChecked, setIsAgeChecked] = useState(true);
    
    // State cho Custom Dropdown chọn số điện thoại
    const [selectedCountry, setSelectedCountry] = useState(COUNTRIES[0]); 
    const [isPhoneDropdownOpen, setIsPhoneDropdownOpen] = useState(false); 

    const { register, handleSubmit, formState: { errors }, getValues, reset } = useForm();
    
    // Đã thêm trường 'paypwd' vào luồng kiểm tra lỗi
    const fieldOrder = ['username', 'password', 'ippassword', 'paypwd', 'name', 'sdt', 'code'];
    const firstErrorField = fieldOrder.find(field => errors[field]);

    useEffect(() => {
        if (login) {
            navigate("/");
        } else {
            const urlParams = new URLSearchParams(window.location.search);
            const refParam = urlParams.get("ref");
            if (refParam) {
                setAffiliate(refParam);
            }
            if (localStorage.getItem("affiliate")) {
                setAffiliate(localStorage.getItem("affiliate"));
            }
        }
        
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        }).catch(()=>{});

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify !== res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        }).catch(()=>{});
    }, []);

    const onSubmit = (data) => {
        if(!isAgeChecked) {
            return swal("Chú ý", "Bạn phải đồng ý với thỏa thuận người dùng và xác nhận trên 18 tuổi.", "warning");
        }

        setIsLoading(true);
        // Đã cập nhật gửi data.paypwd thật thay vì chuỗi rỗng ""
        let formData = {
            username: data.username.toLowerCase(),
            password: data.password,
            code: affiliate ? affiliate : (data.code === "" ? "admin" : data.code),
            sdt: data.sdt,
            name: data.name,
            paypwd: data.paypwd
        };

        axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, formData)
            .then((res) => {
                setIsLoading(false);
                swal({
                    title: "Thông báo", text: "Đăng ký thành công", icon: "success", buttons: "OK"
                }).then(() => {
                    axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                            username: data.username.toLowerCase(),
                            password: data.password
                        })
                        .then((res) => {
                            localStorage.removeItem("user");
                            localStorage.removeItem("profile");
                            localStorage.removeItem("data");
                            localStorage.setItem("user", res.data.data);
                            localStorage.setItem("password", data.password);
                            navigate("/?notify");
                        });
                });
            })
            .catch((err) => {
                setIsLoading(false);
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            });
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#6cd1b0", position: "relative" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                * { box-sizing: border-box; font-family: 'Roboto', sans-serif; }
                body { margin: 0; padding: 0; background: #6cd1b0; }
                
                .r-container {
                    max-width: 500px; margin: 0 auto; width: 100%; 
                    display: flex; flex-direction: column; position: relative; padding: 15px 20px 40px;
                }

                .r-close-btn { position: absolute; top: 15px; right: 20px; color: #b7e8d6; font-size: 28px; cursor: pointer; z-index: 10; font-weight: 300;}

                .r-logo-wrap { display: flex; justify-content: center; margin-top: 30px; margin-bottom: 30px; }
                .r-logo-wrap img { height: 75px; object-fit: contain; }

                .r-form { display: flex; flex-direction: column; gap: 15px; }
                
                .r-input-box {
                    width: 100%; border: none; border-radius: 8px; padding: 14px 15px;
                    background: #fff; font-size: 14px; color: #333; outline: none;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
                }
                .r-input-box::placeholder { color: #5a7d6e; }

                .r-error-text { color: #d32f2f; font-size: 12px; margin-top: -10px; margin-left: 5px; font-weight: 500; }

                .r-phone-row { display: flex; gap: 10px; }
                .r-phone-left {
                    background: #fff; border-radius: 8px; padding: 0 10px;
                    display: flex; align-items: center; justify-content: space-between;
                    width: 110px; cursor: pointer; position: relative;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
                }
                .r-phone-flag { width: 20px; height: 14px; border-radius: 2px; object-fit: cover; }
                .r-phone-code { font-size: 14px; color: #5a7d6e; font-weight: 500; }
                
                .r-dropdown-menu {
                    position: absolute; top: calc(100% + 5px); left: 0; background: #fff;
                    border-radius: 8px; box-shadow: 0 4px 15px rgba(0,0,0,0.2);
                    z-index: 100; max-height: 200px; overflow-y: auto; width: 150px;
                }
                .r-dropdown-item {
                    display: flex; align-items: center; gap: 10px; padding: 10px;
                    cursor: pointer; font-size: 13px; color: #333; border-bottom: 1px solid #f0f0f0;
                }
                .r-dropdown-item:hover { background: #f5f5f5; }

                .r-age-check { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #2e6b52; margin: 5px 0 5px; font-weight: 500; cursor: pointer;}
                .r-checkbox-custom {
                    width: 18px; height: 18px; border-radius: 4px; border: 1px solid #4a9e82; background: #fff;
                    display: flex; align-items: center; justify-content: center; transition: 0.2s;
                }
                .r-checkbox-custom.checked { background: #2ecc71; border-color: #2ecc71; }
                .r-terms { color: #d32f2f; cursor: pointer;}

                .r-btn-row { display: flex; gap: 12px; margin-top: 5px; }
                .r-btn-submit {
                    flex: 1; background: #ffca28; border: 1px solid #f57f17;
                    color: #00695c; font-weight: bold; font-size: 16px; padding: 12px 0;
                    border-radius: 8px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }
                .r-btn-reset {
                    flex: 1; background: linear-gradient(180deg, #b2ead6 0%, #6ec2a3 100%);
                    border: 1px solid #4a9e82; color: #00695c; font-weight: bold; font-size: 16px; 
                    padding: 12px 0; border-radius: 8px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }

                .r-login-link { text-align: center; font-size: 14px; color: #397a63; margin-top: 5px; }
                .r-login-link a { color: #ffb300; text-decoration: none; font-weight: bold; }

                .r-bottom-actions { display: flex; gap: 12px; margin-top: 15px; }
                .r-action-btn {
                    flex: 1; background: linear-gradient(180deg, #dcf5ec 0%, #a4e1ca 100%);
                    border: 1px solid #73c8a9; border-radius: 8px; padding: 12px 0;
                    display: flex; align-items: center; justify-content: center; gap: 8px;
                    color: #000; font-weight: 500; font-size: 15px; cursor: pointer; text-decoration: none;
                }
                .r-action-icon { width: 20px; height: 20px; }
            `}} />

            <div className="r-container">
                <AnimatedPage>
                    
                    <div className="r-close-btn" onClick={() => navigate("/")}>✕</div>

                    <div className="r-logo-wrap">
                        <img alt="Logo" src="/images/logo.png" />
                    </div>

                    <form className="r-form" onSubmit={handleSubmit(onSubmit)}>
                        
                        <input 
                            type="text" 
                            className="r-input-box" 
                            placeholder="Tên người dùng" 
                            autoComplete="off"
                            {...register("username", { 
                                required: "Vui lòng nhập tên người dùng",
                                minLength: { value: 6, message: "Tên người dùng tối thiểu 6 kí tự" },
                                pattern: { value: /^[a-zA-Z0-9]+$/, message: "Không chứa ký tự đặc biệt" }
                            })} 
                        />
                        {firstErrorField === 'username' && <div className="r-error-text">{errors.username.message}</div>}

                        <input 
                            type="password" 
                            className="r-input-box" 
                            placeholder="Mật khẩu" 
                            autoComplete="new-password"
                            {...register("password", { 
                                required: "Vui lòng nhập mật khẩu",
                                minLength: { value: 6, message: "Mật khẩu tối thiểu 6 kí tự" }
                            })} 
                        />
                        {firstErrorField === 'password' && <div className="r-error-text">{errors.password.message}</div>}

                        <input 
                            type="password" 
                            className="r-input-box" 
                            placeholder="Xác nhận mật khẩu" 
                            autoComplete="new-password"
                            {...register("ippassword", { 
                                required: "Vui lòng xác nhận mật khẩu",
                                validate: value => value === getValues("password") || "Hai mật khẩu không khớp"
                            })} 
                        />
                        {firstErrorField === 'ippassword' && <div className="r-error-text">{errors.ippassword.message}</div>}

                        {/* MỚI THÊM: Ô nhập Mật khẩu thanh toán (paypwd) */}
                        <input 
                            type="password" 
                            className="r-input-box" 
                            placeholder="Mật khẩu rút tiền (Thanh toán)" 
                            autoComplete="new-password"
                            {...register("paypwd", { 
                                required: "Vui lòng nhập mật khẩu rút tiền",
                                minLength: { value: 4, message: "Mật khẩu rút tiền tối thiểu 4 kí tự" }
                            })} 
                        />
                        {firstErrorField === 'paypwd' && <div className="r-error-text">{errors.paypwd.message}</div>}

                        <input 
                            type="text" 
                            className="r-input-box" 
                            placeholder="ĐIỀN HỌ TÊN ĐÚNG VỚI HỌ TÊN NGÂN HÀNG ĐỂ RÚT TIỀN" 
                            autoComplete="off"
                            {...register("name", { 
                                required: "Vui lòng nhập họ và tên",
                                validate: value => value.indexOf(" ") !== -1 || "Vui lòng nhập đầy đủ (có dấu cách)",
                                onChange: (e) => e.target.value = e.target.value.replace(/[0-9]/g, '').toUpperCase()
                            })} 
                        />
                        {firstErrorField === 'name' && <div className="r-error-text">{errors.name.message}</div>}

                        <div className="r-phone-row">
                            <div className="r-phone-left" onClick={() => setIsPhoneDropdownOpen(!isPhoneDropdownOpen)}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <div style={{ width: '18px', height: '18px', borderRadius: '50%', backgroundColor: '#d32f2f', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'yellow', fontSize: '10px' }}>★</div>
                                    <span className="r-phone-code">{selectedCountry.code}</span>
                                </div>
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="#5a7d6e"><path d="M7 10l5 5 5-5z"/></svg>

                                {isPhoneDropdownOpen && (
                                    <>
                                        <div style={{position: 'fixed', top:0, left:0, right:0, bottom:0, zIndex: 99}} onClick={(e) => { e.stopPropagation(); setIsPhoneDropdownOpen(false); }}></div>
                                        <div className="r-dropdown-menu">
                                            {COUNTRIES.map((c) => (
                                                <div 
                                                    key={c.code} 
                                                    className="r-dropdown-item"
                                                    onClick={(e) => {
                                                        e.stopPropagation(); setSelectedCountry(c); setIsPhoneDropdownOpen(false);
                                                    }}
                                                >
                                                    <img src={c.flag} alt={c.name} className="r-phone-flag" />
                                                    <span>{c.name} ({c.code})</span>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                            <input 
                                type="number" 
                                className="r-input-box" style={{ flex: 1 }}
                                placeholder="Số điện thoại" 
                                autoComplete="off"
                                {...register("sdt", { 
                                    required: "Vui lòng nhập số điện thoại",
                                    pattern: { value: /^\d{8,15}$/, message: "SĐT không hợp lệ" }
                                })} 
                            />
                        </div>
                        {firstErrorField === 'sdt' && <div className="r-error-text">{errors.sdt.message}</div>}

                        {affiliate == null && (
                            <>
                                <input 
                                    type="text" 
                                    className="r-input-box" 
                                    placeholder="Mã giới thiệu (nếu có)" 
                                    autoComplete="off"
                                    {...register("code")} 
                                />
                            </>
                        )}

                        <div className="r-age-check" onClick={() => setIsAgeChecked(!isAgeChecked)}>
                            <div className={`r-checkbox-custom ${isAgeChecked ? 'checked' : ''}`}>
                                {isAgeChecked && <svg viewBox="0 0 24 24" width="14" height="14" fill="#fff"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>}
                            </div>
                            <span>Tôi trên 18 tuổi, đã đọc và đồng ý với <span className="r-terms">《Thỏa thuận》</span></span>
                        </div>

                        <div className="r-btn-row">
                            <button type="submit" className="r-btn-submit" disabled={isLoading}>
                                {isLoading ? "..." : "Đăng ký"}
                            </button>
                            <button type="button" className="r-btn-reset" onClick={() => reset()}>
                                Làm mới
                            </button>
                        </div>

                        <div className="r-login-link">
                            Quý khách đã có tài khoản? ? <Link to="/login">Đăng nhập ngay</Link>
                        </div>

                        <div className="r-bottom-actions">
                            <Link to="/login" className="r-action-btn">
                                <svg viewBox="0 0 24 24" className="r-action-icon" fill="#00695c"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"/></svg>
                                Trở thành đại lý
                            </Link>
                            <a href="#" className="r-action-btn">
                                <svg viewBox="0 0 24 24" className="r-action-icon" fill="#00695c"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>
                                Tải App
                            </a>
                        </div>
                    </form>

                </AnimatedPage>
            </div>
        </div>
    );
}
export default Register;